import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {CoreModule} from '@catcore/core.module';
import {ProjectDetailsModule} from '@catdetails/project-details.module';

import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ExplorerModule} from '@catmodules/widgets/explorer/explorer.module';
import {GlobalProjectComponent} from '@catproject/components/global-project/global-project.component';
import {GuiImageComponent} from '@catproject/components/gui-image/gui-image.component';
import {TypeSwitchComponent} from '@catproject/components/type-switch/type-switch.component';
import {UIBaseModule} from '@catui/ui-base.module';
import {UIFormModule} from '@catuiform/ui-form.module';
import {ProjectListComponent} from './components/project-list/project-list.component';
import {ProjectComponent} from './components/project/project.component';
import {ConfirmDialogModule, DialogModule, SidebarModule} from "primeng/primeng";
import {UserNotesModule} from "@catmodules/widgets/user-notes/user-notes.module";
import {ProgramsModule} from "@catmodels/programs/programs.module";

@NgModule({
  imports: [
    // common
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,

    // app
    CoreModule,
    UIBaseModule,
    ProjectDetailsModule,
    ProgramsModule,
    UIFormModule,
    ExplorerModule,

    ConfirmDialogModule,
    DialogModule,
    SidebarModule,
    UserNotesModule,

    // StoreModule.forFeature(
    //   'projectList',
    //   {
    //   }),

  ],
  declarations: [
    ProjectComponent,
    ProjectListComponent,
    TypeSwitchComponent,
    GlobalProjectComponent,
    TypeSwitchComponent,
    GuiImageComponent,
  ],
})
export class ProjectModule {
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/project/project.module.ts